export class TestimonialValues {
  static values: {name: string, property: string, details: string, selected: boolean}[] = [
    {
      name: 'Empathetic',
      property: 'empathetic',
      details: 'Demonstrates sensitivity to a client\'s emotional state, and is able to communicate well with warmth and acceptance. Can understand and identify with a clients experiences, \
      even if the client does not describe their thoughts or feelings explicitly to them.',
      selected: false
    },
    {
      name: 'Excellent listener',
      property: 'excellentListener',
      details: 'Demonstrates active listening to clients. Reflects thoughts back to, \
      and is able to remember important events and feelings that the client conveys.',
      selected: false
    },
    {
      name: 'Communicates hope and optimism',
      property: 'communicatesHopeAndOptimism',
      details: 'Acknowledges struggles and yet engenders hope that the client can and will get unstuck.',
      selected: false
    },
    {
      name: 'Non-judgemental',
      property: 'nonJudgemental',
      details: 'Demonstrates acceptance and nonjudgmental attitude – accepts the client for who they are and in their current situation.',
      selected: false
    },
    {
      name: 'Trustworthy',
      property: 'trustworthy',
      details: 'Demonstrates the ability to create trust with a client – client feels understood and believes the therapist is capable of helping them.',
      selected: false
    },
    {
      name: 'Ethical',
      property: 'ethical',
      details: 'Acts within appropriate ethical boundaries. Establishes and maintains healthy boundaries with a client in treatment.',
      selected: false
    },
    {
      name: 'Critical thinker',
      property: 'criticalThinker',
      details: 'Demonstrates the ability to keep up to date on research trends, knows enough about medication to be able to talk to people about any medications they are \
      taking, and can remain mindful of holistic treatments such as mindfulness, exercise herbal therapies, or nutritional changes.',
      selected: false
    },
    {
      name: 'Professional',
      property: 'professional',
      details: 'Demonstrates professionalism through punctuality, reliability, organization, and a clean office environment.',
      selected: false
    },
    {
      name: 'Excellent observation skills',
      property: 'excellentObservationSkills',
      details: 'Notices clients body language and mannerisms. Can help a client notice these things too, in ways that help the client understand themselves better.',
      selected: false
    },
    {
      name: 'Multicultural competency',
      property: 'multiculturalCompetency',
      details: 'Demonstrates the ability to relate to and understand a client regardless of their race, ethnicity, gender, religious or political beliefs or socioeconomic background.',
      selected: false
    },
    {
      name: 'Excellent communicator',
      property: 'excellentCommunicator',
      details: 'Demonstrates communication that is clear and concise. Can explain what is happening to the client and ensures the client can understand what is going on, all while remaining professional and personable.',
      selected: false
    }
  ];

  constructor() {}

  static getValues() {
    return this.values;
  }

}
